module.exports = __webpack_public_path__ + "static/media/question.f404643b.svg";